export default __webpack_public_path__ + "static/media/ic_edit.9426618c.svg";